import React from 'react';
import { Link } from 'react-router-dom';
import core from '@gin-betting/core';
import cn from 'classnames';

import { Action, useAnalyticAttrs } from 'services/analytics';
import { checkIsCmsLink } from 'utils';

const {
    utils: { getBettingOptions },
} = core;

interface OwnProps {
    to: string | null;
    styleName?: string;
    className?: string;
    title?: string;
    onClick?: () => void;
}

type Props = OwnProps;

const SmartLink: React.FC<Props> = ({
    to,
    title,
    className,
    children,
    onClick,
}) => {
    const analytic = useAnalyticAttrs({
        defaultAttrs: { 'data-action': Action.ClickOnLink },
    });
    const bettingOptions = getBettingOptions();

    const linkClassName = cn('__app-SmartLink-link', className);

    if (!to) return null;

    if (bettingOptions.url.pagePath || checkIsCmsLink(to)) {
        return (
            <a
                {...analytic}
                title={title}
                className={linkClassName}
                onClick={onClick}
                href={
                    window.location.origin +
                    (bettingOptions.url.bettingPath + to).replace('//', '/')
                }
            >
                {children}
            </a>
        );
    }

    return (
        <Link
            {...analytic}
            title={title}
            className={linkClassName}
            onClick={onClick}
            to={to}
        >
            {children}
        </Link>
    );
};

export default SmartLink;
